import * as React from "react";

import { navigate } from "helpers/routing";

interface IProps extends React.AnchorHTMLAttributes<HTMLSpanElement> {
  href: string;
}

export const Link: React.FC<IProps> = ({ href, children, ...props }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const handleClick = (event: any) => {
    if (props.target !== "_blank") {
      event.preventDefault();

      if (href) {
        navigate(href);
      }
    }

    return props.onClick && props.onClick(event);
  };

  return (
    <a data-navigate={props.target !== "_blank" && 0} href={href} {...props} onClick={handleClick}>
      {children}
    </a>
  );
};
